<template>
  <div class="header mb10">
    <el-steps class="project-steps" direction="vertical">
      <el-step
        v-for="(item,index) in showSteps"
        :key="item.title"
        :class="[showSteps.length===1?'only-step':'','project-step']"
      >
        <!-- <pre v-if="item.title!=='寻访沟通'" slot="description">
          {{item.description}}
        </pre> -->
        <!-- <p v-if="item.title!=='寻访沟通'" slot="description">
          {{item.description}}
        </p> -->
        <template slot='icon'>
          <div v-if="index===0" class="active-step-circle">
            <div class="line" :style="`background-color:${backgroundColor}`"></div>
          </div>
          <div v-else class="step-circle">
            <div v-if="index===showSteps.length-1" class="line"></div>
          </div>
        </template>
        <template slot='title'>
          <p class="project-step-title">{{item.title}}</p>
        </template>
        <div v-if="item.title !== '寻访沟通'" slot="description">
          <p class="project-step-bolder-description">{{item.bolderDescription}}</p>
          <p>{{ item.description }}</p>
        </div>
        <div v-else slot="description">
          <p class="project-step-bolder-description">目前加入项目 {{ (project.radish_project && project.radish_project.length) || 0 }} 人</p>
          <p>来自行业：</p>
          <p class="project-step-description" :title="(radishProjectDetail['行业'] || []).join('、')">
            {{ (radishProjectDetail['行业'] || []).join('、') }}
          </p>
          <p>来自公司：</p>
          <p class="project-step-description" :title="(radishProjectDetail['公司'] || []).join('、')">
            {{ (radishProjectDetail['公司'] || []).join('、') }}
          </p>
          <p>已沟通：{{ radishProjectDetail.已沟通 }} 人</p>
        </div>
      </el-step>
    </el-steps>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
    backgroundColor: { type: String, default: '#fff' },
  },
  data() {
    return {
      showSteps: [],
      steps: ['寻访沟通', '简历推荐', '安排面试', 'offer谈判', '离职管理', '开票催款'],
      stepMap: {
        人才搜索: '寻访沟通',
        职位推荐: '简历推荐',
        面试阶段: '安排面试',
        offer谈判: 'offer谈判',
        离职管理: '离职管理',
        开票催款: '开票催款',
      },
      radishProjectDetail: {},
    }
  },
  watch: {
    project: {
      async handler(newValue, oldValue) {
        await this.refresh()
      },
      immediate: true,
    },
  },
  methods: {
    async refresh() {
      if (this.refreshing) return
      this.refreshing = true
      this.showSteps = []
      await this.countRadishes()
      this.countSteps()
      this.refreshing = false
    },
    countSteps() {
      const { project, radishProjectDetail } = this
      const radishProject = this.project.radish_project || []
      const label = this.stepMap[this.project.项目阶段]
      const index = this.steps.findIndex(v => v === label)
      const create = {
        title: '项目创建',
        bolderDescription: `${dateFormat(project.createdAt, 'yyyy-mm-dd')} ${project.创建人} 创建项目`,
        description: `参与成员：
    客户开发：${(project['客户开发'] || []).join('、')}
    项目对接：${(project['项目对接'] || []).join('、')}
    项目经理：${(project['项目经理'] || []).join('、')}
    项目成员：${(project['项目成员'] || []).join('、')}`,
      }
      this.showSteps.push(create)
      if (index > -1) {
        const step = {
          title: '寻访沟通',
          bolderDescription: `目前加入项目 ${(project.radish_project && project.radish_project.length) || 0} 人`,
          description: `来自行业：
    ${(radishProjectDetail['行业'] || []).join('、')}
来自公司：
    ${(radishProjectDetail['公司'] || []).join('、')}
已沟通：${radishProjectDetail.已沟通} 人`,
        }
        this.showSteps.unshift(step)
      }
      if (index > 0) {
        const step = {
          title: '简历推荐',
          description: `已推荐 ${radishProjectDetail.已推荐} 人
已淘汰 ${radishProjectDetail.已淘汰} 人`,
        }
        this.showSteps.unshift(step)
      }
      if (index > 1) {
        const step = {
          title: '面试阶段',
          description: `面试 ${radishProjectDetail.面试人数} 人`,
        }

        const obj = {}

        const interviews = window._.cloneDeep(this.project.interviews || [])
        interviews.forEach(v => {
          if (!obj[v.rid] || (obj[v.rid] && obj[v.rid].round < v.round)) obj[v.rid] = v
        })

        const arr = []
        Object.keys(obj).forEach(v => {
          arr.push(obj[v])
        })

        arr.sort((a, b) => new Date(b.面试时间) - new Date(a.面试时间))
        arr.forEach(v => {
          step.description = `${step.description}
    ${v.候选人} 面试第${v.round}轮 ${dateFormat(v.面试时间, 'yyyy-mm-dd')}`
        })
        this.showSteps.unshift(step)
      }
      if (index > 2) {
        const filterRadishProject = radishProject.filter(
          r =>
            r.状态 &&
            ((r.状态.tag === '面试' && r.状态.detail === '终面') || r.状态.tag === 'offer谈判') &&
            r.状态.detail !== '淘汰' &&
            r.状态.detail !== '放弃',
        )

        const step = {
          title: 'offer谈判',
          description: `offer ${filterRadishProject.length} 人`,
        }

        const offers = window._.cloneDeep((this.project.offers || []).filter(v => v.isMaybe))
        const offerRids = offers.map(v => v.rid)
        const interviews = window._.cloneDeep(
          (this.project.interviews || []).filter(v =>
            filterRadishProject.find(
              a => a.rid === v.rid && a.pid === v.pid && !offerRids.includes(a.rid) && a.isFinal,
            ),
          ),
        )

        offers.sort((a, b) => new Date(b.offer签订日期) - new Date(a.offer签订日期))
        interviews.sort((a, b) => new Date(b.面试时间) - new Date(a.面试时间))
        offers.forEach(v => {
          step.description = `${step.description}
    ${v.候选人} 签订${v.isMaybe ? '拟' : ''}offer ${dateFormat(v.offer签订日期, 'yyyy-mm-dd')}`
        })
        interviews.forEach(v => {
          step.description = `${step.description}
    ${v.候选人} 终面 ${dateFormat(v.面试时间, 'yyyy-mm-dd')}`
        })
        this.showSteps.unshift(step)
      }

      if (index > 3) {
        const step = {
          title: '离职管理',
          description: `离职管理 ${(project.offers && project.offers.filter(v => !v.isMaybe).length) || 0} 人`,
        }

        const offers = window._.cloneDeep((this.project.offers || []).filter(v => !v.isMaybe))
        offers.sort((a, b) => new Date(b.offer签订日期) - new Date(a.offer签订日期))

        offers.forEach(v => {
          step.description = `${step.description}
    ${v.候选人} 预计到岗时间 ${dateFormat(v.预计到岗时间, 'yyyy-mm-dd')}`
        })

        this.showSteps.unshift(step)
      }

      if (index > 4) {
        const filterRadishProject = radishProject.filter(
          r =>
            r.状态 &&
            (r.状态.tag === '到岗' || (r.状态.tag === '过保' && !r.状态.detail)) &&
            r.状态.detail !== '淘汰' &&
            r.状态.detail !== '放弃',
        )

        const step = {
          title: '开票催款',
          description: `开票催款 ${(project.toworks && project.toworks.length) || 0} 人`,
        }

        const toworks = window._.cloneDeep(
          (this.project.toworks || []).filter(v => filterRadishProject.find(a => a.rid === v.rid && a.pid === v.pid)),
        )
        toworks.sort((a, b) => new Date(b.到岗日期) - new Date(a.到岗日期))
        toworks.forEach(v => {
          step.description = `${step.description}
    ${v.候选人} 到岗时间 ${dateFormat(v.到岗日期, 'yyyy-mm-dd')}`
        })
        this.showSteps.unshift(step)
      }
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []
      const interviews = this.project.interviews || []
      const offers = this.project.offers || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const out = radishProject.filter(v => v.状态 && v.状态.detail === '淘汰')
      searchRadishDetail.已推荐 = (this.project.recommends || []).length
      searchRadishDetail.已淘汰 = out.length

      const interviewRids = interviews.map(val => val.rid)
      const setObj = new Set(interviewRids)
      searchRadishDetail.面试人数 = [...setObj].length

      const offerNegotiationRids = offers.map(v => v.rid)
      const finalInterviews = interviews.filter(v => v.isFinal)
      finalInterviews.forEach(v => {
        if (!offerNegotiationRids.includes(v.rid)) offerNegotiationRids.push(v.rid)
      })
      searchRadishDetail.offer谈判人数 = offerNegotiationRids.length

      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
  },
}
</script>
<style>
.project-steps .el-step__description {
  white-space: pre-wrap;
}
.project-progress-content-right .el-step__icon.is-icon {
  background-color: #eee;
}
.project-step .el-step__icon {
  background-color: transparent;
}
.project-step .el-step__icon.is-text {
  border: none;
}
.only-step.el-step:last-of-type .el-step__line {
  display: block;
}
</style>
<style scoped>
.project-step {
  height: auto;
}
.bolder {
  font-weight: 700;
}
.project-step-bolder-description {
  color: #262626;
  font-weight: 700;
}
.project-step-title {
  color: #262626;
  font-weight: 600;
  line-height: 22px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 16px;
}
.project-step-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-indent: 2em;
}

.active-step-circle {
  width: 14px;
  height: 14px;
  border: 2px solid #409eff;
  border-radius: 50%;
  position: relative;
}
.active-step-circle .line {
  width: 2px;
  height: 21px;
  position: absolute;
  top: -9px;
  bottom: 0;
  left: 4px;
  background-color: #fff;
  z-index: -1;
}
.step-circle {
  width: 8px;
  height: 8px;
  border: 2px solid #c0c4cc;
  border-radius: 50%;
  background-color: #fff;
}
.step-circle .line {
  width: 2px;
  height: 21px;
  position: absolute;
  top: -13px;
  bottom: 0;
  left: 11px;
  background-color: #c0c4cc;
  z-index: -1;
}
</style>
